import { Controller } from "@hotwired/stimulus"

// Shows or hides the capacity input based on the "registration required"
// checkbox. Reads initial state from the checkbox on connect so the panel
// is visible when editing an event that requires registration.
export default class extends Controller {
  static targets = ["toggle", "panel"]

  connect() {
    this.refresh()
  }

  toggle() {
    this.refresh()
  }

  refresh() {
    if (!this.hasToggleTarget || !this.hasPanelTarget) return
    this.panelTarget.classList.toggle("hidden", !this.toggleTarget.checked)
  }
}
